module.exports = __webpack_public_path__ + "img/home-back-two@2x.97b41344.jpg";